/* global i18n, notify */

import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { flatten, pathEq, reject, values, compose } from 'ramda'
import { isNotEmpty } from 'ramda-adjunct'
import { xhrPost, xhrGet } from '../../../../helpers/http.js'
import { baseUrl } from '../../../../common/constants.js'

import s from '../../style.module.scss'

const BonusPay = () => {
  const flatItemList = useSelector((state) => flatten(values(state.Cart.items)))

  const dispatch = useDispatch()

  const isLoading = useSelector((state) => state.Cart.isLoading)
  const settings = useSelector((state) => state.Cart.settings)
  const balance = useSelector((state) => state.Cart.balance)

  console.log(settings)
  console.log(balance)
  const setIsLoading = (isLoading) => {
    dispatch({
      type: 'Cart.setIsLoading',
      payload: {
        isLoading
      }
    })
  }

  const setItems = (items) => {
    dispatch({
      type: 'Cart.setItems',
      payload: {
        items
      }
    })
  }

  const apiBonusPay = async () => {
    return xhrPost(`${baseUrl}/web/cart/payment/bonus`)
  }

  const apiGetBalance = async () => {
    return xhrGet(`${baseUrl}/web/cart/balance`)
  }

  const getBalance = async () => {
    setIsLoading(true)
    try {
      const balance = await apiGetBalance()
      setBalance(balance.balance)
    } catch (e) {
      console.error('Cart: loadBalance failed', await e.json())
    }
    setIsLoading(false)
  }

  const setBalance = (balance) => {
    console.log(balance)
    dispatch({
      type: 'Cart.setBalance',
      payload: {
        balance
      }
    })
  }

  const bonusPay = async () => {
    setIsLoading(true)
    const dta = await apiBonusPay()

    console.log(dta.status)

    if (dta.status === 400) {
      const errorMessage = Object.keys(dta.messages)
        .map(function (x) {
          return dta.messages[x].message
        })
        .join('<br>')

      notify(i18n.t('global_balance_error'), errorMessage, 'error')
    }

    if (dta.status === 200) {
      let message = ''
      if ('message' in dta) {
        message = dta.message
      } else {
        message = i18n.t('global_balance_sucess')
      }
      notify(i18n.t('global_sucess'), message, 'success')
      if ('cart' in dta) {
        setItems(dta.cart)
      }
    }

    setIsLoading(false)
  }

  const hasBonusPayableItems = compose(
    isNotEmpty,
    reject(pathEq(['commerceinfo', 'statusText'], 'payment pending'))
  )(flatItemList)

  useEffect(() => {
    getBalance()
  }, [])

  return (
    <>
      <h3>{i18n.t('cart_bonus_payment_header')}</h3>
      <div className={s.paymentInfoContainer}>
        <h4>{i18n.t('cart_bank_payment_info_header')}</h4>
        <div className={s.balance}>
          {i18n.t('Your_balance')}: {balance} USDT
        </div>
        <div>{i18n.t('cart_bonus_payment_info_text')}</div>
        <div className={s.bottomButtons}>
          <div className={s.primaryButtons} style={{ float: 'right' }}>
            <button className="btn btn-primary" disabled={isLoading || !hasBonusPayableItems} onClick={bonusPay}>
              {i18n.t('cart_balance_pay')}
            </button>
          </div>
        </div>
      </div>
    </>
  )
}

export default BonusPay
